import { I18n } from '@lingui/core'
import { t } from '@lingui/macro'
import { MetricsByType } from '../../context/reports/workflow/types'
import { TimeFrame } from '../../context/reports/types'

export const getTimeFrameList = (i18n: I18n, sliceCount?: number) => {
  const list = [
    {
      value: TimeFrame.LastMonth,
      label: i18n._(t('time.last_month')`Last Month`)
    },
    {
      value: TimeFrame.Last3Months,
      label: i18n._(t('time.last_three_month')`Last 3 Months`)
    },
    {
      value: TimeFrame.Last6Months,
      label: i18n._(t('time.last_six_months')`Last 6 Months`)
    },
    {
      value: TimeFrame.Last12Months,
      label: i18n._(t('time.last_twelve_months')`Last 12 Months`)
    }
  ]

  return sliceCount ? list.slice(0, sliceCount) : list
}

/**
 *
 * @param timeFrameOption number/enum of selectable months to request
 * @param today optional parameter to make testing easier
 */
export const getTimeFrameRange = (timeFrameOption: TimeFrame, today = new Date()) => {
  const start = new Date(today)
  const end = new Date(today)
  const current = {
    from: '',
    to: ''
  }
  const compare = {
    from: '',
    to: ''
  }

  if (timeFrameOption === TimeFrame.CurrentMonth) {
    // * Start of month up to today
    start.setDate(1)
    current.from = new Date(start).toISOString()
    current.to = new Date(today).toISOString()

    // * Start of previous month up to start of current month
    const startCompare = new Date(current.to)
    const endCompare = new Date(current.from)

    endCompare.setDate(0)
    startCompare.setMonth(startCompare.getMonth() - 1)
    startCompare.setDate(1)
    compare.to = new Date(endCompare).toISOString()
    compare.from = new Date(startCompare).toISOString()
  } else {
    // * `current`
    // * Start of (RANGE) months ago to end of previous month
    start.setDate(1)
    start.setMonth(start.getMonth() - timeFrameOption)
    end.setDate(0)
    current.from = new Date(start).toISOString()
    current.to = new Date(end).toISOString()

    // * `compare`
    // * Start of (2 x RANGE) months ago to end of (RANGE) months ago
    const endCompare = new Date(current.from)
    endCompare.setDate(0)
    compare.to = endCompare.toISOString()

    const startCompare = new Date(compare.to)
    startCompare.setDate(1)
    startCompare.setMonth(startCompare.getMonth() - (timeFrameOption - 1))
    compare.from = new Date(startCompare).toISOString()
  }

  return { timeFrameOption, current, compare }
}

export const BY_TYPE_OPTIONS = {
  [MetricsByType.BySite]: {
    label: 'Site',
    value: MetricsByType.BySite
  },
  [MetricsByType.ByResponsible]: {
    label: 'Team',
    value: MetricsByType.ByResponsible
  }
}
